module.exports = __webpack_public_path__ + "img/doctor_clip.87edbff6.png";